var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file","accept":"image/*","id":"stepFile","capture":"camera"},on:{"change":_vm.photoFun}})])
}
var staticRenderFns = []

export { render, staticRenderFns }